import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import ApiError from '~/types/ApiError';

import { offerQueryKeys } from './useGetOffer';

export function useGetAccount(accountId: string | undefined) {
  return useQuery({
    queryKey: offerQueryKeys.account(accountId),
    queryFn: async ({ signal }) => {
      const response = await OffersService.getAccount(accountId, { signal });
      return response.result;
    },
    enabled: !!accountId,
    retry: (failureCount, error) => (error instanceof ApiError && error.status === 404 ? false : failureCount < 2),
  });
}
